import CategoryService from '@/services/category';
import GameService from '@/services/game';
import TagService from '@/services/tag';

export function loadDataFromServer(lang: string) {
  Promise.all([GameService.getGames(lang), CategoryService.getCategories(lang), TagService.getAllTagsWithLocale(lang)]);
}
